import { PropsWithChildren, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { SidebarContext } from './context';
import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline';

const SidebarSettings = ({ children }: PropsWithChildren<{}>) => {
  const { expanded } = useContext(SidebarContext);
  return (
    <div
      className={twMerge(
        !expanded ? 'xxs:w-[40px]' : 'xxs:w-[208px]',
        'z-20 dark:bg-black-600 xxs:h-screen fixed left-0 top-16 transition-all flex flex-col xxs:pt-4 overflow-hidden drop-shadow xxs:bg-white'
      )}
    >
      {children}
    </div>
  );
};

interface SidebarItemProps {
  icon: typeof ArrowTrendingUpIcon;
  link: string;
}

export const SidebarItem = ({
  icon,
  link,
  children,
}: PropsWithChildren<SidebarItemProps>) => {
  const { expanded } = useContext(SidebarContext);
  const Icon = icon;
  return (
    <NavLink
      to={link}
      className={(active) =>
        active ? 'dark:bg-black-500 xxs:bg-black-50' : 'dark:bg-black-600'
      }
    >
      <div className="flex items-center xxs:py-4 xxs:p-2 xxs:gap-3 dark:text-black-100 xxs:text-black-700 xxs:text-xs">
        <Icon width={24} className="xxs:min-w-[24px]" />
        <div
          className={twMerge(
            !expanded && 'xxs:max-w-0 transition-all overflow-hidden'
          )}
        >
          {children}
        </div>
      </div>
    </NavLink>
  );
};

export default SidebarSettings;
